import MapComponent from '@/components/map';
import './right-panel.styles.css';

const LoginRightPanelCarousel = () => {
	return (
		<div className="relative bg-primary rounded-3xl p-6 h-[976px] outline max-w-[672px] w-[672px]">
			<img alt="First" className="first" src="/images/first.jpeg" />
			<img alt="Second" className="second" src="/images/second.jpeg" />
			<div className="vertical-line" />
			<div className="logo-parent">
				<img alt="Logo" className="logo" src="/images/svg/logo-solo.svg" />
				<span>for Business</span>
			</div>
			<div className="vehicle-container" />
			<img alt="Third" className="third" src="/images/third.jpeg" />
			<img alt="Fourth" className="fourth" src="/images/fourth.jpeg" />
			<div className="vertical-line-white" />
			<div className="circle-container">
				<div className="circle middle" />
				<div className="circle inner" />
			</div>
			<div className="map"><MapComponent /></div>
			<div className="image-rotator">
				<div className="image-rotator-inner">
					<div className="first-slide">
						<img alt="rotating-image" className="rotating-image" src="/images/svg/ETAs-1.svg" />
						<img alt="rotating-image" className="rotating-image" src="/images/svg/ETAs-2.svg" />
						<img alt="rotating-image" className="rotating-image" src="/images/svg/ETAs.svg" />
						<img alt="rotating-image" className="rotating-image" src="/images/svg/ETAs-1.svg" />
					</div>
					<div className="second-slide">
						<img alt="rotating-image" className="rotating-image" src="/images/svg/ETAs-1.svg" />
						<img alt="rotating-image" className="rotating-image" src="/images/svg/ETAs.svg" />
						<img alt="rotating-image" className="rotating-image" src="/images/svg/ETAs-2.svg" />
						<img alt="rotating-image" className="rotating-image" src="/images/svg/ETAs.svg" />
					</div>
					<div className="third-slide">
						<img alt="rotating-image" className="rotating-image" src="/images/svg/ETAs.svg" />
						<img alt="rotating-image" className="rotating-image" src="/images/svg/ETAs-2.svg" />
						<img alt="rotating-image" className="rotating-image" src="/images/svg/ETAs-1.svg" />
						<img alt="rotating-image" className="rotating-image" src="/images/svg/ETAs-2.svg" />
					</div>
				</div>
			</div>
		</div>
	);
};

export default LoginRightPanelCarousel;
